import Quill from 'quill';

/**
 * Quill <https://github.com/quilljs/quill> richText customizado.
 * Qualquer customizacao da biblioteca sera feita aqui, e servida
 * a partir daqui
 */

const icons = Quill.import('ui/icons');
icons.bold = undefined;
icons.italic = undefined;
icons.underline = undefined;
icons.strike = undefined;
icons.list.ordered = undefined;
icons.list.bullet = undefined;

/**
 * Recupera uma lista string[] com os formatos de colagem
 * suportados pelo editor Quill baseado em sua lista
 * de ferramentas (string[])
 */
function getFormatsFromTools(tools) {
  const toolToFormatMapper = {
    pasteFormats: ['bold', 'italic', 'underline', 'strike', 'list', 'indent'],
    bold: ['bold'],
    italic: ['italic'],
    underline: ['underline'],
    strike: ['strike'],
    listOrdered: ['list', 'indent'],
    listBullet: ['list', 'indent'],
  };

  const newFormats = [];
  const seen = {};
  tools.forEach((tool) => {
    const formats = toolToFormatMapper[tool];
    const formatsToAdd = formats.filter((format) => {
      const alreadySeen = !!seen[format];
      if (alreadySeen) return false;
      seen[format] = format;
      return true;
    });

    newFormats.push(...formatsToAdd);
  });
}

export { Quill, getFormatsFromTools };
